import { Select } from "antd";
import React from "react";
import { useTemplate } from "../../utils/Template";

export default function FontPicker(props) {

    const [template, setTemplate] = useTemplate(); 
    const { no_default = false, value = null,  fonts = [], onChange = () => { }, return_object = false } = props;

    // Intercept change to return either an id or full object
    const handleChange = (_id) => {
        if (return_object) {
            let _obj = template.fonts.find(item => item.id === _id);
            if (_obj) {
                onChange(_obj);
                return;
            } else {
                // not found for some reason, return id in an empty object
                onChange({ id: _id });
                return;
            }
        } else {
            onChange(_id);
            return;
        }
    }

    // Draw the fonts
    const drawFonts = () => {
        return template.fonts.map(item => {
            return (<Select.Option key={item.id} value={item.id}><div className={"bm-font-" + item.id} >{item.name}</div></Select.Option>)
        })
    }

    const getDefaultFontName = () => {

        if(no_default){
            return "Poppins";
        }

        let _f = template.fonts.find(item => item.id === template.base_font);
        return (_f) ? _f.name : "Poppins"; 
    }

    return (
        <Select value={(value) ? value : 0} onChange={(e) => handleChange(e)} style={{ "borderBottom": "1px solid #eee", "width": "100%", "maxWidth" : "200px" }} bordered={true}>
            <Select.Option key={0} value={0}><div className={"bm-font-0"} >{getDefaultFontName()} <small><em>(Default)</em></small></div></Select.Option>
            {drawFonts()}
        </Select>
    )
}